import ColumnFlag from "../components/pages/AllTransactions/components/ColumnGrid/ColumnFlag";
import React from "react";

export const transactionColorFlagColumn = (
  flagColors,
  saveTransactionColor,
  _permissions,
  module_key,
) => {
  const modulesForSeeFlags = ["AT"];
  const flagPermission = Boolean(_permissions.transaction?.changeColor);

  let colorFlagColumn = [
    {
      title: "",
      sorting: false,
      field: "flag_column",
      render: ({ _id, color }) => (
        <ColumnFlag
          transactionId={_id}
          hexCode={color}
          flagColors={flagColors}
          saveTransactionColor={saveTransactionColor}
          canChangeColor={flagPermission}
        />
      ),
    },
  ];

  if (!flagPermission) {
    colorFlagColumn = [];
  }

  return modulesForSeeFlags.includes(module_key) ? colorFlagColumn : [];
};
